import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import FormLabel from '@mui/material/FormLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { useColorScheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { COPY } from '../copy';
import { PageHeading } from '../shell/PageHeading';
import { usePageTitle } from '../shell/usePageTitle';

export function PreferencesPage() {
  usePageTitle(COPY.navPreferences);
  const { mode, setMode } = useColorScheme();
  return (
    <Container maxWidth="sm" sx={{ py: { xs: 4, lg: 8 } }}>
      <PageHeading>{COPY.navPreferences}</PageHeading>
      <Typography variant="h2" component="h2" sx={{ mb: 2 }}>
        {COPY.appearanceHeading}
      </Typography>
      <FormControl component="fieldset">
        <FormLabel component="legend">{COPY.themeLabel}</FormLabel>
        <RadioGroup
          name="color-scheme"
          value={mode ?? 'system'}
          onChange={(event) => setMode(event.target.value as 'system' | 'light' | 'dark')}
        >
          <FormControlLabel value="system" control={<Radio />} label={COPY.themeSystem} />
          <FormControlLabel value="light" control={<Radio />} label={COPY.themeLight} />
          <FormControlLabel value="dark" control={<Radio />} label={COPY.themeDark} />
        </RadioGroup>
        <FormHelperText>{COPY.themeHelp}</FormHelperText>
      </FormControl>
      <Divider sx={{ my: 4 }} />
      <Typography variant="body2" color="text.secondary">
        {COPY.morePreferencesSoon}
      </Typography>
    </Container>
  );
}
